// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalContent_form__Uddm3"};